import { render, staticRenderFns } from "./ChartPercentages.vue?vue&type=template&id=25e196a9&"
import script from "./ChartPercentages.vue?vue&type=script&lang=js&"
export * from "./ChartPercentages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports